<script>
import Vue from 'vue';
export default {
    data: () => {
        return {
            loading: true,
            session: undefined,
            currentLang: Vue.state.lang.currentLang
        }
    },
    computed: {
        frameUrl () {
            return `${this.session.widgetHost}?sid=${this.session.sessionId}&lang=${this.currentLang}`;
        },
        lang() {
            return Vue.state.lang.currentLang;
        }
    },
    watch: {
        lang(newLang, oldLang) {
            if (newLang === oldLang) return
            this.changeLang(newLang);
        }
    },
    methods: {
        async init () {
            await Vue.state.toto.session.open();
            this.session = Vue.state.toto.session.get();
            console.log('session=', this.session);
            this.loading = false;
        },
        handleMessage (message) {
            console.log('handleMessage', message)
            if (message.data.source !== 'toto-frame') return;
            if (message.data.type === 'login') {
                this.$router.push({ name: 'login' });
            }
        },
        changeLang(lang){
            const iframeWindow = this.$refs.totoIframe;

            var message = {
                type: 'set',
                key: 'lang',
                value: lang,
            }
            iframeWindow.contentWindow.postMessage(message, '*')
        }
    },
    async mounted () {
        window.addEventListener('message', this.handleMessage)
        await this.init();
        this.changeLang(this.lang);
    }
}
</script>

<template>
  <div>
    <div v-if="loading" class="bng-toto-loading">Loading...</div>
    <div v-else class="columns">
        <iframe ref="totoIframe" class="column bng-toto-frame" :src="frameUrl"></iframe>
    </div>
  </div>
</template>

<style>

</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/toto/toto.vue